export default "__VITE_ASSET__IkNAmiUO__"